import script from "./OperationInstruction.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationInstruction.vue?vue&type=script&setup=true&lang=js"

import "./OperationInstruction.vue?vue&type=style&index=0&id=31f1bd0c&lang=css"

const __exports__ = script;

export default __exports__